// trigger.js
// Decides whether a given incoming group message should prompt the AI
// peer to respond at all. Per-group, multiple-choice setting (see
// settings.js for how the setting itself is communicated/stored) — this
// module is pure decision logic, no I/O, so it's fully unit-testable.

export const TriggerMode = Object.freeze({
  MENTION_ONLY: 'mention-only',
  ALWAYS_LISTENING: 'always-listening'
})

const DEFAULT_MODE = TriggerMode.MENTION_ONLY

/**
 * @param {string} messageText
 * @param {string} aiHandle - e.g. '@ai' — what counts as "mentioning" the AI
 * @param {string} mode - one of TriggerMode
 * @returns {boolean}
 */
export function shouldRespond (messageText, aiHandle, mode = DEFAULT_MODE) {
  if (mode === TriggerMode.ALWAYS_LISTENING) return true
  if (mode === TriggerMode.MENTION_ONLY) {
    return messageText.toLowerCase().includes(aiHandle.toLowerCase())
  }
  throw new Error(`Unknown trigger mode: ${mode}`)
}

export function isValidMode (mode) {
  return Object.values(TriggerMode).includes(mode)
}
